import React from 'react';
import { Navigate, useLocation, useMatch } from 'react-router-dom';

import QualityEventDetails from './QualityEventDetails';

export const EventDetailsRouteGuard: React.FC = () => {
  const isBareEventPath = useMatch({ path: 'events/:eventId', end: true });
  const { search } = useLocation();
  if (isBareEventPath) {
    return <Navigate to={{ pathname: 'details', search }} replace />;
  }
  return <QualityEventDetails />;
};
